// @flow

import {defineMessages} from 'react-intl';

const messages = defineMessages({
  feedbackPromptLabel: {
    id: 'docsApp.clui.feedbackPromptLabel',
    description: 'Label shown when the user first opens the feedback form.',
    defaultMessage: 'Feedback on this experience:',
  },
  optionalResponsePlaceholder: {
    id: 'docsApp.clui.optionalResponseLabel',
    description:
      'Placeholder shown in the textarea for an optional freeform response.',
    defaultMessage: 'Optional response...',
  },
  thumbsUpTitle: {
    id: 'docsApp.clui.thumbsUpMessage',
    description: 'Dialog title shown when a user clicks the thumbs up icon.',
    defaultMessage: 'What do you like about this experience?',
  },
  thumbsDownTitle: {
    id: 'docsApp.clui.thumbsDownMessage',
    description: 'Dialog title shown when a user clicks the thumbs down icon.',
    defaultMessage: "What don't you like about this experience?",
  },
  submitLabel: {
    id: 'docsApp.clui.submitLabel',
    description: 'Label text on the action to submit the feedback form.',
    defaultMessage: 'Submit',
  },
  cancelLabel: {
    id: 'docsApp.clui.cancelLabel',
    description: 'Label text on the action to cancel the feedback form.',
    defaultMessage: 'Cancel',
  },
});

export default messages;
